import { render } from "./BreadcrumbArea.vue?vue&type=template&id=58f8e738"
import script from "./BreadcrumbArea.vue?vue&type=script&lang=js"
export * from "./BreadcrumbArea.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__